import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type TInputs = {
  name: string;
};

const defaultValues: TInputs = {
  name: '',
};

export const NameFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (params.name) setIsActive.on();
    else setIsActive.off();
  }, [params.name]);

  const { register, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values
  const updateValues = () => {
    setValue('name', (params.name as string) ?? '');
  };

  useEffect(() => {
    updateValues();
  }, [params.name]);

  const onSubmit = (data: TInputs) => {
    params.name = data.name;

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  const onClear = () => {
    if (params.name) {
      delete params.name;
      setPageParams(params);
    }

    setValue('name', '');
    onClose();
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <FormLabel>Name</FormLabel>
            <Input size='sm' {...register('name')} />
          </FormControl>

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={onClear}>
              Clear
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
